module.exports = __webpack_public_path__ + "assets/8c584629d6da14efc525609bd6b9b247.jpg";